import React, { createContext } from "react";
import { AccessControl } from "../utils/AccessControl";

export interface IAccessControlContext {
  accessControl: AccessControl;
}

const AccessControlContext = createContext<IAccessControlContext>(null);

export default AccessControlContext;
